import { isMiniProgram } from '@/utils/utils'

const mineRouterList = [
  {
    path: '/mine/index',
    meta: { title: '个人中心' },
    component: () =>
      import(/* webpackChunkName: "index" */ '@/pages/mine/index.vue'),
  },
  {
    path: '/mine/accountInfo',
    meta: { title: '账户信息' },
    component: () =>
      import(
        /* webpackChunkName: "accountInfo" */ '@/pages/mine/accountInfo.vue'
      ),
  },
  {
    path: '/mine/buyRecord',
    meta: { title: isMiniProgram() ? '内容订单' : '我的购买记录' },
    component: () =>
      import(/* webpackChunkName: "buyRecord" */ '@/pages/mine/buyRecord.vue'),
  },
  {
    path: '/mine/historyBrowsing',
    meta: { title: '历史浏览' },
    component: () =>
      import(
        /* webpackChunkName: "historyBrowsing" */ '@/pages/mine/historyBrowsing.vue'
      ),
  },
  {
    path: '/mine/lotteryList',
    meta: { title: '我的抽奖' },
    component: () =>
      import(
        /* webpackChunkName: "lotteryList" */ '@/pages/mine/lotteryList.vue'
      ),
  },
  {
    path: '/mine/address',
    meta: { title: '我的地址' },
    component: () =>
      import(/* webpackChunkName: "lotteryList" */ '@/pages/mine/address.vue'),
  },
  {
    path: '/mine/awardList',
    meta: { title: '我的奖品' },
    component: () =>
      import(/* webpackChunkName: "awardList" */ '@/pages/awardPool/list.vue'),
  },
  {
    path: '/mine/awardDetail',
    meta: { title: '奖品详情' },
    component: () =>
      import(
        /* webpackChunkName: "awardDetail" */ '@/pages/awardPool/detail.vue'
      ),
  },
  {
    path: '/mine/userVerify',
    meta: { title: '自助核销记录' },
    component: () =>
      import(
        /* webpackChunkName: "userVerify" */ '@/pages/mine/userVerify.vue'
      ),
  },
  {
    name: 'collectCard',
    path: '/mine/collectCard',
    meta: { title: '集卡活动' },
    component: () =>
      import(
        /* webpackChunkName: "collectCard" */ '@/pages/mine/collectCard.vue'
      ),
  },
  {
    name: 'collectCardRecord',
    path: '/mine/collectCard/record',
    meta: { title: '领取记录', storePath: '/store/collectCard/record' },
    component: () =>
      import(
        /* webpackChunkName: "collectCard" */
        '@/pages/mine/components/collectCard/cardRecord.vue'
      ),
  },
  {
    name: 'serviceUpgrade',
    path: '/mine/serviceUpgrade',
    meta: { title: '服务升级' },
    component: () =>
      import(
        /* webpackChunkName: "serviceUpgrade" */
        '@/pages/serviceUpgrade/index.vue'
      ),
  },
  {
    name: 'switchLiveRoom',
    path: '/mine/switchLiveRoom',
    meta: { title: '直播间列表' },
    component: () =>
      import(
        /* webpackChunkName: "switchLiveRoom" */
        '@/pages/mine/switchLiveRoom/index.vue'
      ),
  },
]

mineRouterList.forEach(item => {
  if (
    !item.path.includes('mine/index') &&
    !item.path.includes('mine/buyRecord')
  ) {
    item.meta.isNotShare = true
  }
})

export default mineRouterList
